import { Hero, HeroLogo, PageContainer, HeroContainer } from './Home.styles';
import { Images } from '@/assets/images';
import { useAppSelector } from '@/redux';
import Tiles from '@/components/Tiles';

export const Home = () => {
  const language = useAppSelector((state) => state.user.language);

  return (
    <PageContainer>
      <Hero>
        <HeroContainer>
          <HeroLogo
            src={language === 'ar' ? Images.HeroLogoAr : Images.HeroLogoEn}
            style={{ width: language === 'ar' ? '137px' : '242px' }}
            alt="Family Mode"
          />
        </HeroContainer>
      </Hero>
      {/* <Overview /> */}
      <Tiles />
    </PageContainer>
  );
};
